<template>
  <div class="tw-relative tw-flex tw-items-center" :class="inputClass">
    <input
      ref="flatpickr"
      v-focus="focus"
      :value="modelValue"
      class="sf-form-input sf-full-width"
      :class="inputClass"
      v-bind="$attrs"
      type="text"
      :name="name"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="handleValueUpdates"
    />
    <span
      v-if="icon"
      class="
        tw-absolute tw-right-2 tw-flex tw-items-center tw-pointer-events-none
        fa fa-calendar
      "
    />
  </div>
</template>

<script>
import Flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr.js'
import { Dutch } from 'flatpickr/dist/l10n/nl.js'
import 'flatpickr/dist/flatpickr.css'

export default {
  inheritAttrs: false,
  props: {
    options: Object,
    name: String,
    placeholder: String,
    focus: Boolean,
    focusedAt: {
      type: Number,
      default: 0,
    },
    disabled: Boolean,
    hiddenInput: Boolean,
    modelValue: String,
    icon: Boolean,
    customClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue'],

  data() {
    return {
      defaultOptions: {
        allowInput: true,
        dateFormat: 'd/m/Y',
      },
      flatpickr: null,
    }
  },

  computed: {
    currentUserLocale() {
      switch (window.Silverfin.currentUserLocale()) {
        case 'fr':
          return French
        case 'en-AU':
        case 'en':
          return null
        case 'nl':
        default:
          return Dutch
      }
    },

    flatpickrOptions() {
      return Object.assign(
        { locale: this.currentUserLocale },
        this.defaultOptions,
        this.options
      )
    },
    inputClass() {
      return this.hiddenInput ? '!tw-h-0 !tw-p-0' : ''
    },
  },

  watch: {
    modelValue(newValue) {
      this.flatpickr.setDate(newValue)
    },
    focusedAt(newValue) {
      if (newValue) {
        this.flatpickr.open()
      } else {
        this.flatpickr.close()
      }
    },
  },

  mounted() {
    this.flatpickr = new Flatpickr(this.$refs.flatpickr, this.flatpickrOptions)
    if (this.focus) {
      this.flatpickr.open()
    }
  },

  beforeUnmount() {
    if (this.flatpickr) {
      this.flatpickr.destroy()
      this.flatpickr = null
    }
  },

  methods: {
    handleValueUpdates(e) {
      this.$emit('update:modelValue', e.target.value)
    },
  },
}
</script>
